const defaultOptions = { idField: 'uid' };
export default defaultOptions;
